import React, { useState, useEffect } from 'react';
import { Baby, Trophy, Settings, LogOut, Mail, Menu, X } from 'lucide-react';

export default function ParentSidebar({ onLogout }) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const closeMenu = () => setIsOpen(false);

  const handleLeaderboard = () => {
    closeMenu();
    window.open('/leaderboards', '_blank', 'noopener,noreferrer');
  };

  const handleContact = () => {
    closeMenu();
    window.open('/help-center', '_blank', 'noopener,noreferrer');
  };

  return (
    <React.Fragment>
      <header className="mobile-top-bar">
        <button
          type="button"
          className="mobile-menu-btn"
          aria-label="Toggle navigation"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
        <span className="mobile-logo">Knolup</span>
        <div style={{ width: 24 }} />
      </header>

      {isOpen && (
        <div className="sidebar-parent-backdrop" onClick={closeMenu} />
      )}

      <aside className={`sidebar-parent ${isOpen ? 'is-open' : ''}`}>
        <div className="sidebar-parent-logo">Knolup</div>
        <nav>
          <button type="button" className="nav-item active" onClick={closeMenu}>
            <Baby size={20} /> My Children
          </button>
          <button type="button" className="nav-item" onClick={handleLeaderboard}>
            <Trophy size={20} /> Leaderboard
          </button>
          <button type="button" className="nav-item" onClick={closeMenu}>
            <Settings size={20} /> Settings
          </button>
          <button type="button" className="nav-item" onClick={handleContact}>
            <Mail size={20} /> Contact
          </button>
        </nav>
        <button
          type="button"
          className="btn-primary btn-ghost logout-btn-parent"
          onClick={onLogout}
        >
          <LogOut size={18} />
          <span>Logout</span>
        </button>
      </aside>
    </React.Fragment>
  );
}